import styles from "../css/DropDownButton.module.css";
import { ReactComponent as ChevronDown } from "../../../img/iconImgAllChevronDown.svg";
import { DropDownButtonStyle } from "../model/DropDownButtonStyle";
import classNames from "classnames";

interface DropDownButtonProps {
  title: string;
  style?: DropDownButtonStyle;
  handleOnClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function DropDownButton(props: DropDownButtonProps) {
  const titleClass = classNames(styles.titleText, {
    [styles.titleTextTitleStyle]: props.style === DropDownButtonStyle.title,
  });

  const chevronDownImageClass = classNames(styles.chevronDownImage, {
    [styles.chevronDownImageTitleStyle]:
      props.style === DropDownButtonStyle.title,
  });

  return (
    <>
      <button
        type="button"
        className={styles.button}
        onClick={(e) =>
          props.handleOnClick(e as unknown as React.MouseEvent<HTMLDivElement>)
        }
      >
        <span className={titleClass}>{props.title}</span>
        <ChevronDown className={chevronDownImageClass} />
      </button>
    </>
  );
}
